module.exports = __webpack_public_path__ + "img/gi_junggle2048.1d22a188.png";